<template>
  <div>
    <Loader v-if="isLoading" />
    <div v-else class="Content">
      <div class="Content__hero" :style="'background-image: url(' + img(data.imageUrl) + ')'">
        <div class="Content__title">{{ data.title.toLocaleUpperCase("tr") }}</div>
      </div>
      <div class="Content__desc container" v-html="data.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: '',
      isLoading: true
    }
  },
  created() {
    const { slug } = this.$route.params

    this.$http.get(`content/${slug}`).then((res) => {
      this.data = res.data.data
      this.isLoading = false
    })
  }
}
</script>
